module.exports = __webpack_public_path__ + "static/media/b2.ca1621d1.png";